import { useState } from "react";

const contextMenuDefault = {
    visible: false,
    row: null,
    x: 0,
    y: 0,
};

/** Used in React Table component to work with Run.tsx and make a menu appear
 * on mouse right-click.
 */
export default function useContextMenu() {
    const [contextMenu, setContextMenu] = useState(contextMenuDefault);

    function handleContextMenu(e: any, row: any) {
        e.preventDefault();

        setContextMenu({
            visible: true,
            row: row,
            x: e.pageX,
            y: e.pageY,
        });
    }

    function toggle(e: React.MouseEvent) {
        e.stopPropagation();

        setContextMenu({
            ...contextMenuDefault,
            visible: !contextMenu.visible,
        });
    }

    return { contextMenu, handleContextMenu, toggle };
}
